// utils/preloadImages.js

export function preloadImages(urls) {
  const promises = urls.map((url) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = url;

      img.onload = () => resolve();     // resolve on success
      img.onerror = () => resolve();    // resolve even on failure
    });
  });

  return Promise.all(promises); // Resolves when all load attempts complete
}
